import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
}))

function DisplayDocumentType(props) {
  const theme = useTheme();
  const classes = useStyles();
  const [documentTypeName, setDocumentTypeName] = useState([]);

  useEffect(
    () => {
      setDocumentTypeName(getDocumentTypeName)
    },
    [props.documentTypeId]
  );

  const getDocumentTypeName = () => {
    let filtered = props.documentTypes.filter(t => t.documentTypeID === props.documentTypeId)
    return filtered.length > 0 ? filtered[0].name : ""
  }

  return (
    <>
      {documentTypeName}
    </>
  );
}
const mapStateToProps = (state) => ({
  documentTypes: state.prefs.documentTypes,
});

export default connect(
  mapStateToProps
)(withTranslation()(DisplayDocumentType));
